import { apiGet, apiPost } from './apiClient';

const toQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const hostBookings = {
  list: (token, params = {}) => apiGet(`/api/host/bookings${toQuery(params)}`, token),
  get: (id, token) => apiGet(`/api/host/bookings/${id}`, token),
  accept: (id, token) => apiPost(`/api/host/bookings/${id}/accept`, {}, token),
  decline: (id, reason, token) => apiPost(`/api/host/bookings/${id}/decline`, { reason }, token),
  cancelRequest: (id, reason, token) => apiPost(`/api/host/bookings/${id}/cancel-request`, { reason }, token),
  checkin: (id, token) => apiPost(`/api/host/bookings/${id}/mark-checkin`, {}, token),
  checkout: (id, token) => apiPost(`/api/host/bookings/${id}/mark-checkout`, {}, token),
};

export const adminBookings = {
  list: (token, params = {}) => apiGet(`/api/admin/bookings${toQuery(params)}`, token),
  summary: (token, params = {}) => apiGet(`/api/admin/bookings/summary${toQuery(params)}`, token),
  get: (id, token) => apiGet(`/api/admin/bookings/${id}`, token),
  overrideStatus: (id, toStatus, reason, token) =>
    apiPost(`/api/admin/bookings/${id}/status`, { toStatus, reason }, token),
  cancel: (id, payload = {}, token) => apiPost(`/api/admin/bookings/${id}/cancel`, payload, token),
  refund: (id, payload = {}, token) => apiPost(`/api/admin/bookings/${id}/refund`, payload, token),
  payout: (id, payload = {}, token) => apiPost(`/api/admin/bookings/${id}/payout`, payload, token),
};

const withCoreFormat = (params = {}) => ({ ...params, format: 'core' });

export const coreBookings = {
  adminList: (token, params = {}) => apiGet(`/api/admin/bookings${toQuery(withCoreFormat(params))}`, token),
  hostList: (token, params = {}) => apiGet(`/api/host/bookings${toQuery(withCoreFormat(params))}`, token),
  guestList: (token, params = {}) => apiGet(`/api/guest/bookings${toQuery(withCoreFormat(params))}`, token),
};

export const notes = {
  add: (bookingId, note, visible_to_host = false, token) =>
    apiPost(`/api/admin/bookings/${bookingId}/notes`, { note, visible_to_host }, token),
};
